module.exports = __webpack_public_path__ + "8e2391da0472468dfcd44c56051b10cd.png";